<template>
  <div class="container mb-4">
    <vue-headful
      :title="
        `ปืนยี่ห้อ ${
          brandname[this.$route.params.id]
        } - Thong Firearms ร้านปืนธง`
      "
      :keywords="
        `${
          brandname[this.$route.params.id]
        }, Thong Firearms, ปืนธง, ขายปืน, ปืนร้าน`
      "
      :image="
        `http://thongarms.com/src/assets/brand/${
          brandname[this.$route.params.id]
        }.png`
      "
      lang="th"
    />
    <!-- <div class="max-width mt-4">
                 <img v-bind:src="'../src/assets/slide3.jpg'" alt="thong firearms">
    </div>-->
    <b-overlay
      :show="activeArms.length == 0 && loading == false"
      class="d-inline-block width-100"
      bg-color="white"
      opacity="0.9"
      blur="10px"
    >
      <h2 class="mt-4 mb-4">
        {{ brandname[this.$route.params.id] }} |
        <img
          :src="`../src/assets/brand/${brandname[this.$route.params.id]}.png`"
          height="50"
          :title="brandname[this.$route.params.id]"
        />
      </h2>
      <div class="grid-container">
        <div
          class="text-center spinner-grow text-danger"
          role="status"
          v-if="!arms.length"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <div class="row w-100">
          <div
            v-for="arm in activeArms"
            :key="arm.id"
            class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-sm-4 wow fadeIn"
          >
            <div class="item">
              <div class="img-product max-width d-flex align-items-center">
                <img
                  v-bind:src="'/src/assets/product/' + arm.img"
                  :alt="`ปืนยี่ห้อ ${arm.name}`"
                  :title="arm.name"
                />
              </div>

              <div id="product-detail" class="mt-3">
                <h5 :title="arm.name">{{ arm.name }}</h5>
                <b-overlay
                  :show="arm.inStock == 0"
                  class="d-inline-block width-100"
                  bg-color="white"
                  opacity="0.8"
                  blur="10px"
                >
                  <p class="color-70">{{ arm.detail | snippet }}</p>
                  <template v-slot:overlay>
                    <div class="text-center">
                      <h6 class="text-danger">OUT OF STOCK</h6>
                    </div>
                  </template>
                </b-overlay>
              </div>
              <div id="read-more" class="text-center">
                <router-link v-bind:to="/product/ + arm.id" class="btn"
                  >รายละเอียด</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-slot:overlay>
        <div class="text-center mt-5 pt-5">
          <b-icon
            icon="x-circle"
            font-scale="4"
            animation="throb"
            variant="danger"
          ></b-icon>
          <p class="text-danger font-size-25">SOLD OUT!</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import { db } from "../config_db";

//import { setupFirebase } from '../config_db'
// const firebase = setupFirebase({});

// var catid = parseInt(window.location.href.split("=").pop());
// let db = firebase.database();
let armsRef = db.ref("product");

export default {
  components: {
    name: "Brand"
  },
  firebase() {
    return {
      arms: {
        source: armsRef
          .orderByChild("brand")
          .equalTo(Number.parseInt(this.$route.params.id)),
        readyCallback: () => (this.loading = false)
      }
    };
  },
  data() {
    return {
      loading: true,
      brandname: [
        "",
        "BENELLI",
        "BERETTA",
        "BROWNING",
        "COLT",
        "CZ",
        "GLOCK",
        "HENRY",
        "REMINGTON",
        "SMITH&WESSON",
        "STANDARD MFG. (U.S.A.)",
        "TARAN TACTICAL INNOVATIONS JOHN WICK",
        "Zev Technologies",
        "BAIKAL",
        "CMMG",
        "TippMann",
        "DERYA",
        "STACCATO",
        "I.C.R.W.",
        "MOSSBERG",
        "MAXIM DEFENSE",
        "BUL Armory",
        "SIG SAUER",
        "PHOENIX TRINITY"
      ],
      arms: []
    };
  },
  computed: {
    activeArms() {
      let result = this.arms.filter(function(u) {
        return u.show != false && u.show != "FALSE";
      });
      return result.sort((a, b) => (a.category > b.category ? 1 : -1));
    }
  }
  // mounted(){
  //   armsRef
  //       .orderByChild("brand")
  //       .equalTo(Number.parseInt(this.$route.params.id))
  // }
  //   created(){

  //       this.$http.get('https://thongarms-2506.firebaseio.com/product.json').then(function(data){
  //        return data.json();
  //      }).then(function(data){
  //          var dataArray = [];
  //          var brandArray = [];
  //          for(let key in data){
  //             if(key==0){

  //             }else{
  //                dataArray.push(data[key]);
  //             }
  //          }
  //         console.log(dataArray);
  //             this.arms = dataArray;
  //      });
  // 	}
};
</script>



// WEBPACK FOOTER //
// src/component/brand.vue